import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { ImagePlaceholder } from '../ui/ImagePlaceholder';
const BENEFITS = [{
  icon: '🛡️',
  title: 'Pillar 1: Prevention Before Problems',
  desc: 'Before every pour, you run a proven checklist that eliminates the top 12 causes of failed pieces. No more guessing. No more surprises. Just clean, consistent results.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/oKvGeQzSvMqvsQbAJj9a3f/hf_20260228_031502_1f6f9b99-da37-45ec-b4ee-5cf3ba54a036.webp',
  imageAlt: 'Organized flatlay of resin supplies including Resin A, Hardener B, molds, and gloves'
}, {
  icon: '🔧',
  title: 'Pillar 2: Real-Time Error Correction',
  desc: "When something goes wrong — and sometimes it will — you'll know exactly what to do and why it happened. Sticky resin, bubbles, yellowing, dust: every problem has a protocol.",
  imageUrl: 'https://cdn.magicpatterns.com/uploads/dQE11Z5Hjj7UNRdbBkumhN/hf_20260228_030143_1c663672-8114-4b77-8e92-0cdc5fd638f0_(2).webp',
  imageAlt: 'Hands using a heat gun on resin to correct errors'
}, {
  icon: '🏷️',
  title: 'Pillar 3: Sell-Ready From Day One',
  desc: "This isn't about making pretty pieces for your shelf. Every technique, every project, every lesson is designed to end with something you're proud to photograph, list, and sell.",
  extraDesc: 'One sell-ready piece can cover your entire investment — and everything after that is profit.',
  imageUrl: 'https://cdn.magicpatterns.com/uploads/pj9x6HNvr4rnSMJBhXCKS2/hf_20260228_023642_aabef87e-7351-4bcd-b1e6-8861d4aeee62.webp',
  imageAlt: 'Beautiful resin coasters with a $35 price tag'
}];
export function Benefits() {
  return <section className="w-full px-4 md:px-8 max-w-5xl mx-auto flex flex-col items-center" data-id="element-3">
      <FadeIn className="text-center mb-16" data-id="element-4">
        <span className="text-amber font-lato uppercase tracking-widest text-sm font-bold mb-4 block" data-id="element-5">
          Why This Works
        </span>
        <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl text-cream leading-tight text-balance" data-id="element-6">
          This Isn't Another Tutorial.
          <br className="hidden md:block" data-id="element-7" /> It's a System Built Around Your
          Errors.
        </h2>
      </FadeIn>

      <div className="flex flex-col gap-16 md:gap-24 w-full" data-id="element-8">
        {BENEFITS.map((benefit, index) => {
        const isEven = index % 2 === 0;
        return <FadeIn key={index} delay={100} direction="up" className="w-full" data-id="element-9">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-10">
                <div className={`order-2 ${isEven ? 'lg:order-1' : 'lg:order-2'}`} data-id="element-11">
                  <img src={benefit.imageUrl} alt={benefit.imageAlt} className="w-full rounded-lg shadow-xl" data-id="element-12" />
                </div>
                <div className={`order-1 ${isEven ? 'lg:order-2' : 'lg:order-1'}`} data-id="element-13">
                  <h3 className="font-playfair text-3xl md:text-4xl text-amber mb-6" data-id="element-14">
                    {benefit.title}
                  </h3>
                  <p className="font-lato text-lg text-cream/70 leading-relaxed" data-id="element-15">
                    {benefit.desc}
                  </p>
                  {benefit.extraDesc && <p className="font-lato text-lg text-cream/70 leading-relaxed mt-4 font-bold text-amber/90" data-id="element-16">
                      {benefit.extraDesc}
                    </p>}
                </div>
              </div>
            </FadeIn>;
      })}
      </div>
    </section>;
}